import Chart from "chart.js";
import {
  amber,
  blue,
  blueTranslucent,
  green,
  red,
  redTranslucent,
  white,
  black,
} from "../styles/colorCharts";
import moment from "moment-timezone";

const local_date = moment.tz.guess();
const timeZoneOffset = new Date().getTimezoneOffset();
const zone = moment.tz.zone(local_date).abbr(timeZoneOffset);

Chart.defaults.global.defaultFontColor = "#fff";

const thresholdCrossedTurnRed = (chart, threshold, chartId) => {
  if (
    !chart.config ||
    !chart.config.data ||
    !chart.config.data.datasets ||
    chart.config.data.datasets.length === 0
  )
    return;

  if (threshold) {
    $(`#header-${chartId}`).addClass("threshold");
    chart.config.data.datasets[0].backgroundColor = redTranslucent;

    chart.config.data.datasets[0].borderColor = red;
  } else {
    $(`#header-${chartId}`).removeClass("threshold");
    chart.config.data.datasets[0].backgroundColor = "rgb(111, 170, 225, 0.6)";

    chart.config.data.datasets[0].borderColor = blue;
  }
  chart.update();
};

export const displayChartManager = (
  id,
  chart,
  chartType,
  chartLabels,
  chartData,
  threshold,
  stepValue,
  update,
  dateString,
  waterLevelModalData
) => {
  let yAxis, labelTag, labelExtension, chartName, yAxisDataToShow;
  let maxValue = Math.max(...chartData);
  let minValue = Math.min(...chartData);
  let stepValueData = maxValue - minValue;
  let stepValueM;
  if (stepValueData > 6) {
    stepValueM = parseInt(maxValue / 6);
  } else {
    stepValueM = 1;
  }
  if (id == "water-level-modal") {
    chartName = "water-level-modal";
    yAxisDataToShow = waterLevelModalData;
    yAxis = [
      {
        gridLines: {
          display: false,
        },
        ticks: {
          // callback: function (chartLabels) {
          //   return '';
          // },
          fontColor: black,
          max: 45,
          min: 0,
          // reverse: true,
          stepSize: 5,
        },
        beginAtZero: false,
      },
    ];

    labelTag = "Water level";
    labelExtension = "cm";
  } else {
    chartName = "temperature-modal";
    yAxisDataToShow = chartData;
    yAxis = [
      {
        gridLines: {
          display: false,
        },
        // position:'right',
        ticks: {
          fontColor: black,
          // max: parseInt(maxValue) + 1,
          // min: parseInt(minValue) - 1,
          stepSize: stepValueM,
        },
        beginAtZero: false,
        // stepSize: stepValue
      },
    ];
    labelTag = "Temperature";
    labelExtension = "º";
  }
  if (update && chart) {
    thresholdCrossedTurnRed(chart, threshold, id);
    chart.config.data.datasets[0].data = chartData;
    if (id == "water-level-modal") {
      chart.config.data.waterData = waterLevelModalData;
    }
    chart.config.options.scales.yAxes = yAxis;
    chart.config.data.date = dateString;
    chart.config.data.labels = chartLabels;
    chart.update();
  } else {
    const ctx = document.getElementById(id).getContext("2d");
    const config = {
      responsive: true,
      type: chartType,
      data: {
        labels: chartLabels,
        date: dateString,
        waterData: yAxisDataToShow,
        datasets: [
          {
            pointRadius: 0,
            // pointHitRadius: 200,
            data: chartData,
            backgroundColor: "rgba(100, 16, 219, 0.3)",
            borderColor: blue,
            borderWidth: 1,
          },
        ],
      },
      options: {
        hover: {
          mode: "index",
          intersect: false,
        },
        tooltips: {
          callbacks: {
            title: function (tooltipItem, data) {
              return data["date"][tooltipItem[0]["index"]];
            },
            label: function (tooltipItem, data) {
              // if (chartName == 'water-level-modal') {
              //   return `${labelTag}: ${data['waterData'][tooltipItem['index']]}${labelExtension}`;
              // }
              // else {
              return `${labelTag}: ${
                data["datasets"][0]["data"][tooltipItem["index"]]
              }${labelExtension}`;
              // }
            },
            // titleFontSize: 16,
            // bodyFontSize: 16,
          },
          backgroundColor: "white",
          titleFontSize: 14,
          borderColor: "black",
          borderWidth: 1,
          titleFontColor: "#000",
          bodyFontColor: "#000",
          bodyFontSize: 14,
          displayColors: false,
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: yAxis,
          xAxes: [
            {
              ticks: {
                fontColor: black,
              },
            },
          ],
        },
      },
    };
    chart = new Chart(ctx, config);
    thresholdCrossedTurnRed(chart, threshold, id);
  }

  return chart;
};
// export const realtimeChart = (id, chart, chartType, chartLabels, chartData, threshold, stepSize, update) => {
//   let yAxis;
//   if (id == 'waterLevel') {
//     yAxis = [{
//       ticks: {
//         callback: function (chartLabels) {
//           return chartLabels + '%';
//         },
//         max: 100,
//         min: 0,
//         stepSize: stepSize
//       }
//     }]
//   }
//   else {
//     yAxis = {
//       beginAtZero: false
//     }
//   }
//   if (update && chart) {
//     thresholdCrossedTurnRed(chart, threshold, id);
//     chart.config.data.datasets[0].data.push(chartData);
//     chart.config.data.datasets[0].data.shift();
//     chart.config.data.labels.push(chartLabels);
//     chart.config.data.labels.shift();
//     chart.update();
//   } else {
//     const ctx = document.getElementById(id).getContext('2d');
//     const config = {
//       responsive: true,
//       type: chartType,
//       data: {
//         labels: chartLabels,
//         datasets: [{
//           data: chartData,
//           backgroundColor: blueTranslucent,
//           borderColor: blue,
//           borderWidth: 1,
//         }],
//       },
//       options: {
//         tooltips: {
//           mode: 'nearest',
//         },
//         legend: {
//           display: false,
//         },
//         scales: {
//           yAxes: yAxis
//         },
//       },
//     };
//     chart = new Chart(ctx, config);
//     thresholdCrossedTurnRed(chart, threshold, id);
//   }

//   return chart;
// };

export const groupLineChart = (id, chart, update) => {
  const ctx = document.getElementById(id).getContext("2d");
  if (update && chart) {
    chart.update();
  } else {
    const config = {
      type: "line",
      data: {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
        ],
        datasets: [
          {
            fillColor: "rgba(220,220,220,0.2)",
            strokeColor: "rgba(220,220,220,1)",
            data: [65, 59, 80, 81, 56, 55, 40],
          },
          {
            fillColor: "rgba(151,187,205,0.2)",
            strokeColor: "rgba(151,187,205,1)",
            data: [28, 48, 40, 19, 86, 27, 90],
          },
        ],
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    };
    chart = new Chart(ctx, config);
  }
};

export const realtimeChart = (
  id,
  chart,
  chartType,
  chartLabels,
  chartData,
  threshold,
  stepSize,
  update,
  dateString,
  waterLevelData,
  depthOfPit,
  filter
) => {
  let filterTitle = filter !== "Latest 10 Records" && filter !== "1 Day";
  let yAxis, labelTag, labelExtension, chartName, yAxisDataToShow;
  let maxValue = Math.max(...chartData);
  let minValue = Math.min(...chartData);
  let stepValueData = maxValue - minValue;
  let stepValue;
  if (stepValueData > 6) {
    stepValue = parseInt(maxValue / 6);
  } else {
    stepValue = 1;
  }
  if (id == "waterLevel") {
    chartName = "waterLevel";
    yAxisDataToShow = waterLevelData;
    yAxis = [
      {
        scaleLabel: {
          display: true,
          fontSize: 14,
          fontColor: "black",
          labelString: "Depth (Cms)",
        },
        gridLines: {
          display: false,
        },
        ticks: {
          // callback: function () {
          //   return '';
          // },
          fontColor: black,
          max: depthOfPit,
          min: 0,
          stepSize: parseInt(depthOfPit / 10),
        },
      },
    ];
    labelTag = "Water level";
    labelExtension = "cm";
  } else if (id == "temperature") {
    chartName = "temperature";
    yAxisDataToShow = chartData;
    yAxis = [
      {
        gridLines: {
          display: false,
        },
        scaleLabel: {
          display: true,
          fontSize: 14,
          fontColor: "black",
          labelString: "Temperature (Celsius)",
        },
        ticks: {
          fontColor: black,
          max: parseInt(maxValue) + 2,
          min: parseInt(minValue) === 0 ? 0 : parseInt(minValue) - 2,
          stepSize: stepValue,
        },
        beginAtZero: false,
      },
    ];
    labelTag = "Temperature";
    labelExtension = "º";
  } else {
    chartName = "current";
    yAxisDataToShow = chartData;
    yAxis = [
      {
        gridLines: {
          display: false,
        },
        scaleLabel: {
          display: true,
          fontSize: 14,
          fontColor: "black",
          labelString: "Power (Amp)",
        },
        ticks: {
          fontColor: black,
          max: parseInt(maxValue) + 2,
          min: parseInt(minValue) === 0 ? 0 : parseInt(minValue) - 2,
          stepSize: stepValue,
        },
        beginAtZero: false,
      },
    ];
    labelTag = "Power";
    labelExtension = " Amp";
  }
  if (update && chart) {
    thresholdCrossedTurnRed(chart, threshold, id);
    chart.config.data.datasets[0].data = chartData;
    if (id === "waterLevel") {
      chart.config.data.waterData = waterLevelData;
    }
    chart.config.options.scales.yAxes = yAxis;
    chart.config.options.scales.xAxes = [
      {
        // gridLines: {
        //   display: false,
        // },
        ticks: {
          fontColor: black,
        },
        scaleLabel: {
          display: true,
          fontSize: 14,
          fontColor: "black",
          labelString: filterTitle ? `Date (${zone})` : `Time (${zone})`,
        },
      },
    ];
    chart.config.data.date = dateString;
    chart.config.data.labels = chartLabels;
    chart.update();
  } else {
    const ctx = document.getElementById(id).getContext("2d");
    const config = {
      responsive: true,
      type: chartType,
      data: {
        labels: chartLabels,
        date: dateString,
        waterData: yAxisDataToShow,
        datasets: [
          {
            pointRadius: 0,
            pointHitRadius: 60,
            data: chartData,
            backgroundColor: "rgba(100, 16, 219, 0.3)",
            borderColor: blue,
            borderWidth: 1,
          },
        ],
      },
      options: {
        hover: {
          mode: "index",
          intersect: false,
        },
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            title: function (tooltipItem, data) {
              return data["date"][tooltipItem[0]["index"]];
            },
            label: function (tooltipItem, data) {
              // if (chartName == 'waterLevel') {
              //   return `${labelTag}: ${data['waterData'][tooltipItem['index']]}${labelExtension}`;
              // }
              // else {
              return `${labelTag}: ${
                data["datasets"][0]["data"][tooltipItem["index"]]
              }${labelExtension}`;
              // }
            },
          },
          backgroundColor: "white",
          titleFontSize: 14,
          borderColor: "black",
          borderWidth: 1,
          titleFontColor: "#000",
          bodyFontColor: "#000",
          bodyFontSize: 14,
          displayColors: false,
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: yAxis,
          xAxes: [
            {
              // gridLines: {
              //   display: false,
              // },
              ticks: {
                fontColor: black,
              },
              scaleLabel: {
                display: true,
                fontSize: 14,
                fontColor: "black",
                labelString: `Time (${zone})`,
              },
            },
          ],
        },
      },
    };
    chart = new Chart(ctx, config);
    thresholdCrossedTurnRed(chart, threshold, id);
  }

  return chart;
};

export const pitStatusSteppedCharts = (
  id,
  chart,
  chartType,
  chartData,
  timeStamp,
  timeWithDate,
  yAxisData,
  update,
  filter
) => {
  const timeData = timeWithDate;
  let filterTitle = filter !== "Latest 10 Records" && filter !== "1 Day";
  let color, borderForPit;
  if (chartData[chartData.length - 1] === "Open") {
    $(`#header-${id}`).addClass("threshold");
    borderForPit = red;
    color = redTranslucent;
  } else {
    $(`#header-${id}`).removeClass("threshold");
    borderForPit = blue;
    color = "rgb(111, 170, 225, 0.6)";
  }

  if (update && chart) {
    chart.config.data.datasets[0].backgroundColor = color;
    chart.config.data.datasets[0].borderColor = borderForPit;
    chart.config.data.datasets[0].data = yAxisData;
    chart.config.data.status = chartData;
    chart.config.data.labels = timeStamp;
    (chart.config.options.scales.xAxes = [
      {
        scaleLabel: {
          display: true,
          fontSize: 14,
          fontColor: "black",
          labelString: filterTitle ? `Date (${zone})` : `Time (${zone})`,
        },
        gridLines: {
          display: false,
        },
        ticks: {
          fontColor: black,
        },
      },
    ]),
      (chart.config.data.timeDataToShow = timeData);
    chart.update();
  } else {
    const ctx = document.getElementById(id).getContext("2d");
    const config = {
      responsive: true,
      type: chartType,
      data: {
        labels: timeStamp,
        status: chartData,
        timeDataToShow: timeData,
        datasets: [
          {
            pointRadius: 5,
            pointHitRadius: 60,
            data: yAxisData,
            backgroundColor: color,
            borderColor: borderForPit,
            borderWidth: 1,
            steppedLine: true,
          },
        ],
      },
      options: {
        hover: {
          mode: "index",
          intersect: false,
        },
        animation: false,
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            title: function (tooltipItem, data) {
              return `${data.timeDataToShow[tooltipItem[0]["index"]]}`;
            },
            label: function (tooltipItem, data) {
              return `Status: ${data["status"][tooltipItem["index"]]}`;
            },
          },
          backgroundColor: "white",
          titleFontSize: 14,
          borderColor: "black",
          borderWidth: 1,
          titleFontColor: "#000",
          bodyFontColor: "#000",
          bodyFontSize: 14,
          displayColors: false,
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {
                callback: function (data) {
                  if (data === 1) {
                    return "Open";
                  } else if (data === 0) {
                    return "Closed";
                  } else {
                    return "";
                  }
                },
                fontColor: "black",
                max: 1.2,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                fontSize: 14,
                fontColor: "black",
                labelString: `Time (${zone})`,
              },
              gridLines: {
                display: false,
              },
              ticks: {
                fontColor: black,
              },
            },
          ],
        },
      },
    };
    chart = new Chart(ctx, config);
  }
  return chart;
};

export const getBubbleColor = (color) => {
  switch (color) {
    case "Red":
      return red;
    case "Green":
      return green;
    case "Amber":
      return amber;
  }
};

export const pitStatusBubbleChart = (id, chart, type, chartData, update) => {
  const Y_VALUE = 20,
    RADIUS = 20;
  if (update && chart) {
    if (
      !chart.config ||
      !chart.config.data ||
      !chart.config.data.datasets ||
      chart.config.data.datasets.length === 0
    )
      return;

    const xValue = chart.config.data.datasets[0].data.length;
    let value, labelValue, colorValue, date;

    if (chartData.date && chartData.details) {
      value = { x: xValue, y: Y_VALUE, r: RADIUS };
      labelValue = chartData.details;
      date = chartData.date;
      colorValue = getBubbleColor(chartData.color);

      if (chartData.date == chart.config.data.labels[xValue - 1]) {
        chart.config.data.datasets[0].data.pop();
        chart.config.data.labels.pop();

        chart.config.data.datasets[0].details.pop();
        chart.config.data.datasets[0].backgroundColor.pop();

        chart.config.data.labels.push(date);
        chart.config.data.datasets[0].data.push(value);

        chart.config.data.datasets[0].backgroundColor.push(colorValue);
        chart.config.data.datasets[0].details.push(labelValue);
      } else {
        chart.config.data.labels.push(date);
        chart.config.data.labels.shift();

        chart.config.data.datasets[0].data.push(value);
        chart.config.data.datasets[0].data.shift();

        chart.config.data.datasets[0].backgroundColor.push(colorValue);
        chart.config.data.datasets[0].backgroundColor.shift();

        chart.config.data.datasets[0].details.push(labelValue);
        chart.config.data.datasets[0].details.shift();
      }
    }
    chart.update();
  } else {
    let chartValues = [];
    let valuesLabels = [];
    let valueColors = [];
    let date = [];
    let i = 1;
    chartData.map((item) => {
      if (item.date && item.details) {
        chartValues.push({ x: i++, y: Y_VALUE, r: RADIUS });
        valuesLabels.push(item.details);
        date.push(item.date);
        valueColors.push(getBubbleColor(item.color));
      } else {
        chartValues.push({ x: i++, y: Y_VALUE, r: 0 });
        valuesLabels.push("");
        valueColors.push("");
        date.push(item.date);
      }
    });

    // console.log("### chartValues", chartValues, valueColors, valuesLabels);
    date.reverse();
    valueColors.reverse();
    valuesLabels.reverse();
    chartValues.reverse();
    const ctx = document.getElementById(id).getContext("2d");
    const config = {
      responsive: true,
      maintainAspectRatio: true,
      data: {
        labels: date,
        datasets: [
          {
            type: type,
            backgroundColor: valueColors,
            data: chartValues,
            details: valuesLabels,
            borderColor: valueColors,
          },
          {
            type: "line",
            data: chartValues,
            details: valuesLabels,
            fill: false,
            borderColor: white,
          },
        ],
      },
      options: {
        elements: {
          point: {
            radius: 0,
          },
        },
        legend: {
          display: false,
        },
        tooltips: {
          custom: function (tooltip) {
            if (!tooltip) return;
            // disable displaying the color box;
            tooltip.displayColors = false;
          },
          callbacks: {
            // use label callback to return the desired label
            label: function (tooltipItem, data) {
              //return "Testing Tooltip :" + tooltipItem.xLabel;
              return data.datasets[0].details[tooltipItem.index];
            },
            title: function () {
              return;
            },
          },
        },
        scales: {
          xAxes: [
            {
              offset: true,
              display: true,
              ticks: {
                // display: false,
                beginAtZero: true,
                fontSize: 9,
              },
              gridLines: {
                display: false,
                // lineWidth: 1,
                color: white,
              },
            },
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                display: false,
                beginAtZero: false,
              },
              gridLines: {
                display: false,
                // lineWidth: 1,
                color: white,
              },
            },
          ],
        },
      },
    };
    chart = new Chart(ctx, config);
  }
  return chart;
};



// WEBPACK FOOTER //
// ./util/chartManager.js